/* eslint-disable prettier/prettier */ 'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { renderSanitizedHtml } from '@whitbread-eos/utils';
import { useTranslation, formatIBAssetsUrl, cn } from '@whitbread-eos/utils/server';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
const Footer = ()=>{
    const { t } = useTranslation([
        'common',
        'footer'
    ]);
    const addSocialMediaButtons = ()=>{
        const socialMediaIcons = t('footer.socialMediaIcons');
        if (!Array.isArray(socialMediaIcons)) return;
        return socialMediaIcons === null || socialMediaIcons === void 0 ? void 0 : socialMediaIcons.map((item)=>{
            var _item_linkSrc, _item_label;
            return /*#__PURE__*/ _jsx(Link, {
                href: (_item_linkSrc = item.linkSrc) !== null && _item_linkSrc !== void 0 ? _item_linkSrc : '/',
                passHref: true,
                legacyBehavior: true,
                children: /*#__PURE__*/ _jsx("a", {
                    target: "_blank",
                    children: /*#__PURE__*/ _jsx(Image, {
                        width: 24,
                        height: 24,
                        alt: (_item_label = item === null || item === void 0 ? void 0 : item.label) !== null && _item_label !== void 0 ? _item_label : '',
                        src: formatIBAssetsUrl(item === null || item === void 0 ? void 0 : item.iconSrc)
                    })
                })
            }, item === null || item === void 0 ? void 0 : item.label);
        });
    };
    const addTabs = ()=>{
        const tabs = t('footer.tabs');
        if (!Array.isArray(tabs)) return;
        return tabs === null || tabs === void 0 ? void 0 : tabs.map((tab)=>{
            var _tab_columns;
            return /*#__PURE__*/ _jsx("div", {
                className: cn('links-container', linksContainerStyle),
                children: tab === null || tab === void 0 ? void 0 : (_tab_columns = tab.columns) === null || _tab_columns === void 0 ? void 0 : _tab_columns.map((column)=>{
                    var _column_linkItems;
                    return /*#__PURE__*/ _jsxs("div", {
                        className: linksColumnStyle,
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: linksTitle,
                                children: column === null || column === void 0 ? void 0 : column.name
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: linksStyle,
                                children: column === null || column === void 0 ? void 0 : (_column_linkItems = column.linkItems) === null || _column_linkItems === void 0 ? void 0 : _column_linkItems.map((link)=>{
                                    var _link_linkSrc;
                                    return /*#__PURE__*/ _jsx(Link, {
                                        className: linkStyle,
                                        href: (_link_linkSrc = link === null || link === void 0 ? void 0 : link.linkSrc) !== null && _link_linkSrc !== void 0 ? _link_linkSrc : '/',
                                        passHref: true,
                                        legacyBehavior: true,
                                        children: link === null || link === void 0 ? void 0 : link.name
                                    }, link === null || link === void 0 ? void 0 : link.name);
                                })
                            })
                        ]
                    }, column === null || column === void 0 ? void 0 : column.name);
                })
            }, tab === null || tab === void 0 ? void 0 : tab.name);
        });
    };
    const addBottomLinks = ()=>{
        const bottomLinks = t('footer.bottomLinks');
        if (!Array.isArray(bottomLinks)) return;
        return bottomLinks === null || bottomLinks === void 0 ? void 0 : bottomLinks.map((link)=>{
            var _link_linkSrc;
            return /*#__PURE__*/ _jsxs(React.Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: separatorStyle
                    }),
                    /*#__PURE__*/ _jsx(Link, {
                        href: (_link_linkSrc = link === null || link === void 0 ? void 0 : link.linkSrc) !== null && _link_linkSrc !== void 0 ? _link_linkSrc : '/',
                        passHref: true,
                        legacyBehavior: true,
                        children: /*#__PURE__*/ _jsx("a", {
                            target: (link === null || link === void 0 ? void 0 : link.openInNewTab) ? '_blank' : '',
                            children: link === null || link === void 0 ? void 0 : link.name
                        })
                    })
                ]
            }, link === null || link === void 0 ? void 0 : link.name);
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": "IB-Footer",
        className: footerWrapperStyle,
        children: [
            addTabs(),
            /*#__PURE__*/ _jsxs("div", {
                className: bottomSectionStyle,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        "data-testid": "IB-Footer-Quick-Links",
                        className: quickLinksStyle,
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                children: renderSanitizedHtml(t('footer.copyrightInfo'))
                            }),
                            addBottomLinks()
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        "data-testid": "IB-Social-Media-Links",
                        className: socialMediaContainerStyle,
                        children: addSocialMediaButtons()
                    })
                ]
            })
        ]
    });
};
export default Footer;
const footerWrapperStyle = 'py-12 px-12 w-full mobile:py-6 mobile:px-4';
const linksContainerStyle = 'flex flex-wrap border-y-[1px] border-lightGrey3 pt-12 pb-12 w-full gap-x-4 gap-y-12 mobile:flex-col';
const linksColumnStyle = 'flex flex-grow flex-col w-[calc(25%-1rem)] mobile:w-full';
const linksTitle = 'text-lg leading-6 mb-4 font-bold text-darkGrey1';
const linksStyle = 'flex flex-col gap-2';
const linkStyle = 'leading-6 text-darkGrey1';
const bottomSectionStyle = 'flex mt-8 justify-between mobile:flex-col mobile:gap-y-6';
const separatorStyle = 'w-[4px] h-[4px] rounded-full bg-lightGrey1';
const quickLinksStyle = 'flex items-center gap-4 text-darkGrey1 text-sm flex-wrap';
const socialMediaContainerStyle = 'flex gap-4';
